export const SIGNATURE_COMPONENT_DEFAULT_HEIGHT = 34;
export const SIGNATURE_COMPONENT_DEFAULT_WIDTH = 134;
export const SIGNATURE_COMPONENT_MINIMUM_WIDTH = 36;
export const DEFAULT_TEXT_SIGNATURE_LABEL = 'Text';
export const CONTRACT_COMPONENT_DEFAULT_HEIGHT = 22;
export const CONTRACT_COMPONENT_DEFAULT_WIDTH = 134;
export const CONTRACT_COMPONENT_MINIMUM_WIDTH = 24;
